export const StationDataTypes = {
  "SET_STATION_DATA_URL": "SET_STATION_DATA_URL",
  "SET_STATION_DATA": "SET_STATION_DATA",
  "SET_FILTERED_STATION_DATA": "SET_FILTERED_STATION_DATA"
};